import React, { useState, useEffect } from "react";
import { Field, useFormikContext } from "formik";
import { toAbsoluteUrl } from "../../../../_helpers";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { LuPanelLeftClose, LuPanelRightClose } from "react-icons/lu";
// import { GoPlusCircle,GoMinusCircle } from "react-icons/go";
// import { FaMinus, FaPlus } from "react-icons/fa6";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { BASE_URL, NODE_API_URL } from "../../../../../env_config";
import axios from "axios";
import Cookies from "js-cookie";
export const Shape = ({ language , setLoader,errorMsg , setErrorMsg}) => {
    const [shapeNames,setShapeName] = useState([]);
    useEffect(() => {
        axios({
            method: "get",
            url: process.env.REACT_APP_ENV === "production"?`https://api.oasis.diamondsoncall.online/admin/getShapes`:`https://api.immitation.diamondsupload.com/admin/getShapes`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            }
        })
            .then(function (res) {
                setLoader(false)
                if (res && res.data.success && res.data.data) {
                    setShapeName(res.data.data)
                }
            })
            .catch(function (res) {
                setLoader(false)
                if (res?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }
                    window.location.replace(`${BASE_URL}/logout`);
                }
            });
    }, []);
    const ShapeData = shapeNames.map((value, index) => ({
        id: index + 1,
        value
    }));

    const [shapeLimit, setShapeLimit] = useState(12);
    const [selectedShapes, setSelectedShapes] = useState([]);
    const { setFieldValue, values } = useFormikContext();

    useEffect(() => {
        setFieldValue("Shape_all", selectedShapes.length === ShapeData.length);
    }, [selectedShapes, setFieldValue]);

    const showMoreShape = () => setShapeLimit(ShapeData.length);
    const showLessShape = () => setShapeLimit(12);

    const handleSelectAll = () => {
        setErrorMsg("")
        const newSelectedAll = !values.Shape_all;
        setFieldValue("Shape_all", newSelectedAll);
        setSelectedShapes(newSelectedAll ? ShapeData.map(item => item.value) : []);
        setFieldValue("Shape", newSelectedAll ? ShapeData.map(item => item.value) : []);
    };

    const handleSelectShape = (value) => {
        setErrorMsg("")
        const newSelectedShapes = selectedShapes.includes(value)
            ? selectedShapes.filter(item => item !== value)
            : [...selectedShapes, value];
        setSelectedShapes(newSelectedShapes);
        setFieldValue("Shape", newSelectedShapes);
    };

    return (
        <div className="row mt-5 pb-10 border-bottom">
            <div className="col-lg-2">
                <p className="font-size-lg font-weight-bold mb-0">{language.SHAPE_SHAPE}</p>
            </div>
            <div className="col-lg-10 flex-wrap d-flex">
                <label className="search_btn_check">
                    <input
                        type="checkbox"
                        name="Shape_all"
                        id="shape_all"
                        onChange={handleSelectAll}
                        checked={values.Shape_all}
                    />
                     <div className={`${errorMsg === "Please Select Shape and Carat to continue with search." || errorMsg === "Please Select Shape to continue with search." || errorMsg === "Please select at least one filter" ? "border border-danger" : ""} shapeBox selectBox d-flex align-items-center justify-content-center`}>
                        <span className="text-uppercase font-size-h1">ALL</span>
                    </div>
                </label>
                
                {ShapeData.slice(0, shapeLimit).map((item) => (
                    <label key={item.id} className="search_btn_check">
                        {/* {item.value.toLowerCase()} */}
                        <Field
                            type="checkbox"
                            name="Shape"
                            id={`${item.value}_shape`}
                            value={item.value}
                            checked={selectedShapes.includes(item.value)}
                            onChange={() => handleSelectShape(item.value)}
                        />
                        <div className={`shapeBox selectBox ${errorMsg === "Please Select Shape and Carat to continue with search." || errorMsg === "Please Select Shape to continue with search." || errorMsg === "Please select at least one filter" ? "border border-danger" : ""}`}>
                            <SVG className={`${item.value.toLowerCase()}_shape`} src={toAbsoluteUrl(`/media/shape/svg_shape/${item.value.toLowerCase()}.svg`)} />
                            <br />
                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">{item.value}</Tooltip>}>
                                <span className="text-uppercase text-truncate">{item.value}</span>
                            </OverlayTrigger>
                        </div>
                    </label>
                ))}
                {ShapeData.length > 12 &&
                    <span className="search_btn_check" onClick={shapeLimit === ShapeData.length ? showLessShape : showMoreShape}>
                        <div className={`shapeBox selectBox ${errorMsg === "Please Select Shape and Carat to continue with search." || errorMsg === "Please Select Shape to continue with search." || errorMsg === "Please select at least one filter" ? "border border-danger" : ""}`}>
                            {shapeLimit === ShapeData.length ? <CiCircleMinus /> : <CiCirclePlus />}<br />
                            <span className="text-uppercase text-truncate">{shapeLimit === ShapeData.length ? "Less" : "More"}</span>
                        </div>
                    </span>
                }
            </div>
        </div>
    );
};
